import Component from "~/route-containers/partner/offers.container";
import { offersLoader } from "~/loaders/offers.loader";
import { MetaFunction } from "@remix-run/node";

export const meta: MetaFunction = ({ params, matches, data }) => {
  const parentsData = matches[0]?.data;
  const storeMetadata = parentsData?.storeMetadata;
  const city = storeMetadata?.storeCity;
  const country = storeMetadata?.country;
  const { partnerId } = params;
  const customTitle = data?.customTitle
    ?.replace("{{partnerId}}", partnerId)
    ?.replace("{{country}}", country);
  const customDescription = data?.customDescription
    ?.replace("{{partnerId}}", partnerId)
    ?.replace("{{city}}", city);
  return [
    { name: "charset", content: "utf-8" },
    { title: customTitle },
    { name: "description", content: customDescription },
    {
      name: "viewport",
      content: "width=device-width,initial-scale=1,maximum-scale=1",
    },
    { name: "og:title", content: "Ofertas" },
  ];
};

export { offersLoader as loader };

export default Component;
